<template>
    <div ref="artRef"></div>
</template>
<script>
import Artplayer from 'artplayer';

export default {
  props: {
    option: {
      type    : Object,
      required: true,
    },
  },
  data() {
    return {
      instance: null,
    };
  },
  mounted() {
    this.instance = new Artplayer({
      ...this.option,
      container: this.$refs.artRef,
    });
    this.$nextTick(() => {
      this.$emit('get-instance', this.instance);
    });
  },
  beforeUnmount() {
    if (this.instance && this.instance.destroy) {
      this.instance.destroy(false);
    }
  },
};
</script>
<style lang="sass">
i.art-icon.art-icon-state
    display: none

.art-video-player.art-notice-show .art-notice
    display: none

.art-video-player
    z-index: 1

    &art-bottom
        z-index: 1


</style>
